module.exports = __webpack_public_path__ + "static/img/haidilao-bg.81db631.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/haidilao-bg.png
// module id = nzSw
// module chunks = 2